__webpack_require__.p = "https://static.finncdn.no/_c/travel/currency-web/_next/";